import yup from 'validation';
import valid from "card-validator";

const arrMails = [
  'gmail.com',
  'hotmail.com',
  'aol.com',
  'yahoo.com',
  'hotmail.co.uk',
  'hotmail.fr',
  'yahoo.fr',
  'wanadoo.fr',
  'orange.fr',
  'msn.com',
];

const schema = yup
  .object()
  .shape({
    firstName: yup.string().required().min(3).alphaApostrophe(),
    lastName: yup.string().required().min(3).alphaApostrophe(),
    email: yup.string().required().email(),
    phone: yup.string().required().min(10),
    name: yup.string().required().min(3).alphaApostrophe(),
    cardNumber: yup
          .string()
          .required()
          .min(16)
          .test(
              'credit_card',
              'Credit Card number is invalid', //validation message
              (value) => valid.number(value).isValid
          ),
    expirationMonth: yup.number().required(),
    expirationYear: yup.number().required(),
    cvv: yup.string().required().min(3),
    address: yup.string().required().min(3),
    zip: yup.string().required().min(3),
    city: yup.string().required().min(3),
  })
  .required();

export { arrMails, schema };
